import { useState, useCallback, useEffect } from "react";
import "./v2-style.css";

import { LuUsers } from "react-icons/lu";
import { GoZap } from "react-icons/go";
import { FaRegStar } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";
import { MdOutlineHeadphones } from "react-icons/md";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import SkeletonSubscriptionCard from "../../../components/skeleton-loading/subscription-cards";
import TopupModal from "../../wallet/components/topup-modal";
import api from "../../../services/api";

const SubscriptionSection = () => {
  // Original functionality states
  const currentUser = useSelector((state) => state?.auth?.user);
  const [subscriptionPackages, setSubscriptionPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalPayment, setTotalPayment] = useState();
  const [subscriptionObject, setSubscriptionObject] = useState({});

  const fetchSubscriptionPackages = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get("/subscriptions");

      const transformedData = data?.data?.map((x) => {
        const isCurrent = currentUser?.subscriptionId === x?.id ? true : false;

        return {
          ...x,
          isCurrent,
        };
      });

      setSubscriptionPackages(transformedData);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser?.id) {
      fetchSubscriptionPackages();
    }
    // eslint-disable-next-line
  }, [currentUser]);

  // Original handleBuyNow function
  const handleBuyNow = (plan, type) => {
    setIsModalOpen(true);
    let subscriptionObj = {
      id: plan?.id,
      teacherId: currentUser?.id,
      type: "SUB_PAYMENT",
      isYearly: type === "month" ? false : true,
    };
    // console.log("obj", plan);
    const price =
      type === "month" ? plan.price : plan?.otherFeatures?.yearlyPrice;
    const finalPrice = calculateDiscountedPrice(price, plan.discountPrecentage);
    // console.log("final price", finalPrice);
    setSubscriptionObject(subscriptionObj);
    setTotalPayment(finalPrice);
  };

  const getFeatureIcon = (featureName) => {
    switch (featureName.toLowerCase()) {
      case "student offers":
        return <LuUsers className="feature-icon text-dark" />;
      case "student demos":
        return <GoZap className="feature-icon text-dark" />;
      case "badge":
        return <FaRegStar className="feature-icon text-dark" />;
      case "profile visibility":
        return <IoShieldCheckmarkOutline className="feature-icon text-dark" />;
      case "public profile":
        return <LuUsers className="feature-icon text-dark" />;
      case "availability status":
        return <FaCheck className="feature-icon text-dark" />;
      case "support":
        return <MdOutlineHeadphones className="feature-icon text-dark" />;
      default:
        return <IoShieldCheckmarkOutline className="feature-icon text-dark" />;
    }
  };

  const formatFeatureValue = (val) => {
    if (val === true) return "✓";
    if (val === false) return "✗";
    return val;
  };

  const calculateDiscountedPrice = (price, discountPercentage) => {
    if (discountPercentage > 0) {
      return price - (price * discountPercentage) / 100;
    }
    return price;
  };

  const getPlanIcon = (planName) => {
    switch (planName.toLowerCase()) {
      case "free":
        return <LuUsers className="plan-icon" />;
      case "basic":
        return <GoZap className="plan-icon" />;
      case "pro":
        return <FaRegStar className="plan-icon" />;
      default:
        return <IoShieldCheckmarkOutline className="plan-icon" />;
    }
  };

  if (isLoading) {
    return (
      <>
      <div className="row text-start mb-2">
        <div className="col-12 mb-2">
          <h1 className="pageTitle">Choose your Subscription Plan</h1>
          <p
            className="mt-2"
            style={{
              fontFamily: "poppins",
              color: "#6c757d",
              fontSize: "1rem",
            }}
          >
            Select the plan that fits your teaching needs and goals. Upgrade
            or downgrade at any time.
          </p>
          {/* <hr /> */}
        </div>
      </div>
      <div className="row">
        {[1, 2, 3].map((_, index) => (
          <SkeletonSubscriptionCard key={index} />
        ))}
      </div>
      </>
    );
  }

  return (
    <>
      <div className=" subscription-section">
        <div>
          <div className="row text-start mb-2">
            <div className="col-12 mb-2">
              <h1 className="pageTitle">Choose your Subscription Plan</h1>
              <p
                className="mt-2"
                style={{
                  fontFamily: "poppins",
                  color: "#6c757d",
                  fontSize: "1rem",
                }}
              >
                Select the plan that fits your teaching needs and goals. Upgrade
                or downgrade at any time.
              </p>
              {/* <hr /> */}
            </div>
          </div>

          <div className="row justify-content-center">
            {subscriptionPackages?.map((plan) => {
              const isPopular = plan.name === "Basic";
              const hasYearlyPrice = plan.otherFeatures.yearlyPrice;

              return (
                <div key={plan.id} className="col-lg-4 col-md-6 mb-4">
                  <div
                    className={`subscription-card ${
                      plan.isCurrent ? "current-plan" : ""
                    } `}
                  >
                    {/* {isPopular && (
                      <div className="popular-badge">Most Popular</div>
                    )} */}

                    {plan.isCurrent && (
                      <div className="current-badge">Active</div>
                    )}

                    <div className="card-body p-4">
                      <div className="plan-header">
                        <div className="plan-info">
                          <div className="plan-icon-wrapper">
                            {getPlanIcon(plan.name)}
                          </div>
                          <div>
                            <h3 className="plan-name">{plan.name}</h3>
                            {plan.discountPrecentage > 0 && (
                              <div className="discount-badge">
                                {plan.discountPrecentage}% OFF
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="pricing-section">
                        <div className="monthly-price">
                          <div className="price-display">
                            <span className="price-main">
                              RS{" "}
                              {Math.floor(
                                calculateDiscountedPrice(
                                  plan.otherFeatures.monthlyPrice || plan.price,
                                  plan.discountPrecentage
                                )
                              )}
                            </span>
                            {plan.discountPrecentage > 0 && (
                              <span className="price-original">
                                RS{" "}
                                {Math.floor(
                                  plan.otherFeatures.monthlyPrice || plan.price
                                )}
                              </span>
                            )}
                          </div>
                          <p className="price-period">per month</p>
                        </div>

                        {hasYearlyPrice && (
                          <div className="yearly-price">
                            <div className="price-display">
                              <span className="price-main">
                                RS{" "}
                                {Math.floor(
                                  calculateDiscountedPrice(
                                    plan.otherFeatures.yearlyPrice,
                                    plan.discountPrecentage
                                  )
                                )}
                              </span>
                              {plan.discountPrecentage > 0 && (
                                <span className="price-original">
                                  RS{" "}
                                  {Math.floor(plan.otherFeatures.yearlyPrice)}
                                </span>
                              )}
                            </div>
                            <p className="price-period">
                              per year
                              <span className="savings-badge">
                                Save{" "}
                                {Math.round(
                                  ((plan.otherFeatures.monthlyPrice * 12 -
                                    plan.otherFeatures.yearlyPrice) /
                                    (plan.otherFeatures.monthlyPrice * 12)) *
                                    100
                                )}
                                %
                              </span>
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="features-list">
                        {plan.otherFeatures.features.map((feature, index) => (
                          <div key={index} className="feature-item">
                            <div className="feature-left">
                              {getFeatureIcon(feature.name)}
                              <span className="feature-name">
                                {feature.name}
                              </span>
                            </div>
                            <span
                              className={`feature-value ${
                                feature.val === false
                                  ? "unavailable"
                                  : "available"
                              }`}
                            >
                              {formatFeatureValue(feature.val)}
                            </span>
                          </div>
                        ))}
                      </div>

                      <div className="action-buttons">
                        {plan.isCurrent ? (
                          <button
                            className="btn btn-subscription btn-disabled w-100"
                            disabled
                          >
                            Current Plan
                          </button>
                        ) : plan.name.toLowerCase() === "free" ? (
                          <button
                            className="btn btn-subscription btn-outline-custom w-100"
                            // onClick={() => handleBuyNow(plan, "month")}
                          >
                            Get Started
                          </button>
                        ) : (
                          <div className="d-flex gap-2 w-100">
                            <button
                              className="btn-subscription btn-primary-custom flex-fill fs-14"
                              onClick={() => handleBuyNow(plan, "month")}
                            >
                              Get Monthly
                            </button>
                            {hasYearlyPrice && (
                              <button
                                className="btn btn-subscription btn-outline-custom flex-fill"
                                onClick={() => handleBuyNow(plan, "year")}
                              >
                                Get Yearly
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <TopupModal
          show={isModalOpen}
          title={"Subscription Payment"}
          onCancel={() => setIsModalOpen(false)}
          type="SUBSCRIPTION"
          subscriptionAmount={totalPayment}
          subObj={subscriptionObject}
        />
      )}
    </>
  );
};

export default SubscriptionSection;
